import axios from 'axios';
// import { API_BASEURL } from '../../environment';




export const contactUs = async (formData) => {
    try {
        const responseContact = await axios.post(`https://four-seasons-backend.onrender.com/api/user/contactUs`,
            formData
        );
        console.log(responseContact.data, "reponseContact");
        return responseContact.data;
    }
    catch (error) {
        console.log("Contact error", error.msg)
        throw error;
    }

}